export var TestIds = {
  WritingForm: 'writing-form'
};
export var CUIIconSizes;
(function (CUIIconSizes) {
  CUIIconSizes["XSMALL"] = "xsmall";
  CUIIconSizes["SMALL"] = "small";
  CUIIconSizes["MEDIUM"] = "medium";
  CUIIconSizes["LARGE"] = "large";
})(CUIIconSizes || (CUIIconSizes = {}));